import { render } from "./AddUserGroup.vue?vue&type=template&id=685ecb71"
import script from "./AddUserGroup.vue?vue&type=script&lang=js"
export * from "./AddUserGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__